export const FriendSvg = (isDarkmode: boolean, theme) => {
  const backgroundColor = isDarkmode ? '#474747' : '#EEBB9F';

  return [
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_800_1664)">
        <path
          d="M25.5209 51.3684V64.8959C25.5209 65.8409 26.1275 66.678 27.0259 66.9755C27.2505 67.0484 27.4809 67.0834 27.7084 67.0834C28.3909 67.0834 29.05 66.7626 29.47 66.1909L37.383 55.4226L25.5209 51.3684Z"
          fill={backgroundColor}
        />
        <path
          d="M69.0814 0.405675C68.4106 -0.0697415 67.5297 -0.133908 66.8006 0.248175L1.17555 34.519C0.399713 34.9244 -0.0582036 35.7528 0.00596306 36.6248C0.0730464 37.4998 0.653463 38.2465 1.47888 38.5294L19.7226 44.7653L58.5756 11.5444L28.5105 47.7665L59.086 58.2169C59.3135 58.2928 59.5526 58.3336 59.7918 58.3336C60.1885 58.3336 60.5822 58.2257 60.9293 58.0157C61.4835 57.6773 61.8597 57.1086 61.956 56.4698L69.9768 2.51151C70.0964 1.69484 69.7522 0.884008 69.0814 0.405675Z"
          fill={backgroundColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_800_1664">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>,
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.644409 56.5317C0.644409 57.3172 1.27435 57.9318 2.04445 57.9318H39.6763C39.6202 57.4699 39.6063 57.0078 39.6063 56.5317C39.6063 48.7479 45.0942 42.2238 52.4022 40.6418C49.2522 36.0078 44.7722 32.4379 39.6623 30.3379C36.6523 32.5219 32.9703 33.8098 28.9663 33.8098C24.9624 33.8098 21.2524 32.5079 18.2423 30.3098C7.92436 34.5519 0.644409 44.7019 0.644409 56.5317Z"
        fill={backgroundColor}
      />
      <path
        d="M44.4782 15.4978C44.4782 6.95796 37.5202 0 28.9662 0C20.4122 0 13.4683 6.95796 13.4683 15.4978C13.4683 24.0518 20.4122 31.0098 28.9662 31.0098C37.5202 31.0098 44.4782 24.0519 44.4782 15.4978Z"
        fill={backgroundColor}
      />
      <path
        d="M69.3556 56.532C69.3556 49.098 63.3091 43.05 55.8876 43.05C48.4536 43.05 42.4056 49.098 42.4056 56.532C42.4056 63.952 48.4536 70 55.8876 70C63.3091 70 69.3556 63.952 69.3556 56.532ZM62.2003 53.8439L54.853 61.1898C54.5799 61.4627 54.2216 61.6 53.8632 61.6C53.5062 61.6 53.1479 61.4627 52.8734 61.1898L49.5709 57.8871C49.0235 57.3397 49.0235 56.4536 49.5709 55.9077C50.1183 55.3601 51.0031 55.3601 51.5505 55.9077L53.8632 58.2204L60.2207 51.8645C60.7681 51.3169 61.6529 51.3169 62.2003 51.8645C62.7477 52.4119 62.7477 53.2967 62.2003 53.8439Z"
        fill={backgroundColor}
      />
    </svg>,
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1178 55.8823 0 36 0C16.1178 0 0 16.1178 0 36C0 55.8823 16.1178 72 36 72Z"
        fill={backgroundColor}
      />
      <path
        d="M39.7368 31.5685V27.3169H49.41V20.6101H22.5648V27.3169H32.2632V31.5685C24.138 31.9609 18.0396 33.5917 18.0396 35.5285C18.0396 37.4653 24.1308 39.1033 32.2632 39.4885V53.5285H39.7368V39.4885C47.862 39.0997 53.9604 37.4689 53.9604 35.5285C53.9604 33.5881 47.88 31.9609 39.7368 31.5685ZM36 38.2501C27.2016 38.2501 20.07 36.8893 20.07 35.2513C20.07 33.8437 25.2648 32.6593 32.256 32.3425V37.1449C33.4584 37.1989 34.7076 37.2313 35.9928 37.2313C37.278 37.2313 38.5344 37.1989 39.7296 37.1449V32.3425C46.7208 32.6593 51.9156 33.8437 51.9156 35.2513C51.93 36.9073 44.7984 38.2501 36 38.2501Z"
        fill={theme.COLORS.listIconBorder}
      />
    </svg>,
    <svg
      width="72"
      height="62"
      viewBox="0 0 72 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.88141 48.603V60.274C4.88141 60.9841 5.45831 61.5758 6.18312 61.5758H15.2064C15.9164 61.5758 16.5081 60.9989 16.5081 60.274V39.7424L9.95514 46.2954C8.56467 47.6711 6.78961 48.4698 4.88141 48.603Z"
        fill={backgroundColor}
      />
      <path
        d="M21.0049 39.5945V60.274C21.0049 60.984 21.5818 61.5757 22.3067 61.5757H31.3299C32.0399 61.5757 32.6316 60.9988 32.6316 60.274V48.1C30.5755 48.0556 28.6525 47.2421 27.2029 45.7924L21.0049 39.5945Z"
        fill={backgroundColor}
      />
      <path
        d="M37.1285 46.813V60.2739C37.1285 60.9839 37.7054 61.5756 38.4302 61.5756H47.4535C48.1635 61.5756 48.7552 60.9987 48.7552 60.2739V35.4377L38.4154 45.7775C38.016 46.1769 37.5871 46.5171 37.1285 46.813Z"
        fill={backgroundColor}
      />
      <path
        d="M64.006 20.1721L53.252 30.9261V60.2739C53.252 60.9839 53.8289 61.5756 54.5537 61.5756H63.577C64.287 61.5756 64.8787 60.9987 64.8787 60.2739V20.9857C64.5829 20.7342 64.361 20.5123 64.1983 20.3644L64.006 20.1721Z"
        fill={backgroundColor}
      />
      <path
        d="M71.3873 1.11979C70.9583 0.661236 70.3075 0.424561 69.4791 0.424561C69.4052 0.424561 69.3164 0.424561 69.2424 0.424561C65.0414 0.61686 60.8552 0.823951 56.6542 1.01625C56.0921 1.04583 55.3229 1.07542 54.7165 1.6819C54.5242 1.8742 54.3762 2.09608 54.2579 2.36234C53.6366 3.70844 54.5094 4.58118 54.9235 4.99536L55.9738 6.0604C56.6986 6.80001 57.4382 7.53962 58.1778 8.26444L32.7944 33.6627L21.3896 22.2579C20.7091 21.5774 19.792 21.1929 18.8157 21.1929C17.8394 21.1929 16.9371 21.5774 16.2567 22.2579L1.06504 37.4347C-0.355014 38.8548 -0.355014 41.1476 1.06504 42.5676L1.74548 43.2481C2.42593 43.9285 3.34304 44.3131 4.31933 44.3131C5.29562 44.3131 6.19794 43.9285 6.87839 43.2481L18.8157 31.3107L30.2205 42.7156C30.901 43.396 31.8181 43.7806 32.7944 43.7806C33.7707 43.7806 34.673 43.396 35.3682 42.7156L64.006 14.0778L67.2455 17.3025C67.6301 17.6871 68.1626 18.2196 68.9762 18.2196C69.3164 18.2196 69.6566 18.1309 70.0116 17.9386C70.2483 17.8054 70.4554 17.6575 70.6329 17.48C71.269 16.8439 71.3873 16.0304 71.4169 15.3943C71.5352 12.6725 71.6684 9.95076 71.8015 7.21419L71.9938 3.11675C72.0382 2.2588 71.8459 1.59315 71.3873 1.11979Z"
        fill={backgroundColor}
      />
    </svg>,
  ];
};
